<template>
    <layout-gestao v-cloak>
        <div class="row">
            <div class="col-sm-12">
                <form autocomplete="off" method="post" data-vv-scope="form" @keyup.enter="saveItem" @submit.prevent="">
                    <div class="row mb-3">
                        <div class="col-sm-auto">
                                <h1 class="content-title">{{ titleItem }}</h1>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-sm-12">
                            <div class="form-group">
                                <MaterialInput
                                    :readonly="readonlyFormItem"
                                    type="text" class="city-form-group city-bg"
                                    id="input-name"
                                    name="name"
                                    v-model.trim="form.name"
                                    v-validate="'required|min:3'"
                                    :inputClasses="[{'is-invalid': fnHasError('name') }]"
                                    :error=" fnFirstError('name')">
                                    {{ $t(`${pageID}.model.name`) }}
                                </MaterialInput>
                            </div>
                        </div>
                    </div>
                    <buttons-footer
                        :enableButtons="!readonlyFormItem"
                        :cancelTitle="cancelTitle"
                        :submitTitle="submitTitle"
                        :isDisabled="isDisabled"
                        @save="saveItem"
                        @cancel="handleBack(`${moduleCode}.${pageID}`)"
                    >
                    </buttons-footer>
                </form>
            </div>
        </div>
    </layout-gestao>
</template>

<script>
    import mixin from '../../mixin'

      export default {
        mixins: [mixin],
        data() {
              return {
                pageID: 'priorities',
                form: {
                    id: null,
                    name: "",
                },
              }
        },
      }
</script>
